const rx = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/

const isValid24hTime = str => !!str.match(rx)

export {isValid24hTime}
